import React, { Fragment } from 'react';

const InsurancePolicyCoverage = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      You are covered by two insurance policies when driving our vehicles:
    </p>
    <ol>
      <li>
        <strong>Rideshare insurance</strong> - covers you while you are
        “online” a rideshare driver app. This insurance policy covers up to
        $2MM for third-party liability and maintains a $2,500 deductible.
        If you opt-in to Autzu’s reduced deductible plan, your deductible
        becomes $1,000.
      </li>
      <li>
        <strong>Commercial insurance</strong> - covers you when “offline” a
        rideshare driver app, such as taking breaks, refueling at gas
        stations, and driving in and out of the Autzu parking lot. This
        insurance policy covers up to $2MM for third-party liability and
        maintains a $2,500 deductible. If you opt-in to Autzu’s reduced
        deductible plan, your deductible becomes $1,000.
      </li>
      <br />
    </ol>
    <p>
      See <a href="#accidents-and-insurance">Accidents and Insurance</a>{' '}
      section for full details.
    </p>
  </Fragment>
);

export default InsurancePolicyCoverage;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/InsurancePolicyCoverage.js